import { api, post } from './api.ts';
import { setTenantSlug } from './tenant.ts';

/** CR-067: 계정 단계 API (조직이 정해지기 전) */
export interface AccountMe { id: string; email: string; name: string; verifiedBy: 'password' | 'magic_link' | 'sso'; hasPassword: boolean; passwordChangedAt: string | null }
export interface Workspace { tenantId: string; slug: string; name: string; suspended: boolean; role: string; status: 'active' | 'invited'; lastLoginAt: string | null; requires: { sso: boolean; mfa: boolean; passwordChange: boolean } }
export type EnterResult = { status: 'ok' | 'mfa_required' | 'mfa_enroll_required'; tenant: { slug: string; name: string } } | { status: 'sso' | 'handoff'; url: string; tenant: { slug: string; name: string } };

export const ROLE_LABEL: Record<string, string> = { platform_admin: '플랫폼 관리자', tenant_admin: '테넌트 관리자', ciso: 'CISO', ciso_staff: 'CISO 부서', dept_manager: '부서 담당자', auditor: '감사인', viewer: '열람자' };

export const accountMe = () => api<AccountMe>('/account/me');
export const workspaces = () => api<Workspace[]>('/account/workspaces');

/**
 * 조직 진입. 반환값은 이동할 경로(SPA 내부) 또는 null(브라우저가 IdP·커스텀 도메인으로 떠남).
 * 조직 세션이 발급되면 이후 API 요청의 X-Tenant-Slug 로 쓰도록 슬러그를 저장한다.
 */
export async function enterWorkspace(tenantId: string, returnTo?: string): Promise<string | null> {
  const r = await post<EnterResult>('/account/enter', { tenantId, returnTo });
  if (r.status === 'sso' || r.status === 'handoff') { window.location.assign(r.url); return null; }
  setTenantSlug(r.tenant.slug);
  return r.status === 'ok' ? (returnTo ?? '/') : r.status === 'mfa_required' ? '/mfa' : '/mfa/enroll';
}
